module.exports = __webpack_public_path__ + "img/Eventos_Build.660bc216.png";